interface props {
  size?: number
  background?: string
}

export const SeparatorDot = ({
  size = 3.2,
  background = 'bg-text-tertirary',
}: props) => {
  return (
    <div
      className={background}
      style={{ width: size, height: size, borderRadius: '50%' }}
    />
  )
}
